import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ConnectorService} from './api/connector.service';

@Injectable({
    providedIn: 'root'
})
export class StatisticService extends ConnectorService {

    getIndexPageStatistics(currentPage: 'contracts' | 'docs' | 'tasks' | 'products' | 'office'): Observable<any> {
        return this.get('instance/index/get', {counter_key: currentPage});
    }
}
